<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end d-flex align-items-center">
              <div class="me-2" style="flex: 1;">
             
                  <b-button
                v-b-modal.new-customer
                size="sm"
                variant="primary"
                @click="clearFields"
                ><i class="mdi mdi-plus"></i> New Customer</b-button
              >
              </div>

              <div class="me-2" style="flex: 1;">
                <b-button 
                  v-b-modal.new-customer-import 
                  size="sm" 
                  variant="success" 
                  class="w-100">  
                  <i class="mdi mdi-upload"></i> Import Customers
                </b-button>
              </div>

              <div class="me-2" style="flex: 1;">
                 <export-excel 
                 class="btn btn-warning w-100" 
                 :data="exportData()"
                 name="CUSTOMERS.xls">
                 Export <i class="mdi mdi-download"></i>
                </export-excel>
              </div>
 
              <div style="flex: 1;">
                  <button 
                    @click="downloadCsv" 
                    class="btn btn-secondary btn-sm w-100"> 
                    <i class="mdi mdi-download"></i> Download Customer's Template
                  </button>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby.full_name }}
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="
                        edit(
                          data.item.id,
                          data.item.name,
                          data.item.contact,
                          data.item.email,
                          data.item.location
                        )
                      "
                    >
                      <span v-if="loader"><b-spinner small/></span>
                      <span v-else
                        ><i class="mdi mdi-square-edit-outline"></i
                      ></span>
                    </button>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="remove(data.item.id, data.item.name)"
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="new-customer"
      centered
      title="New Customer  "
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addCustomer">
        <div class="form-group mb-2">
          <label>Customer Name</label>
          <input v-model="name" type="text" required class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Email</label>
          <input v-model="email" type="text" class="form-control" />
        </div>
        <div class="row">
          <div class="col-md-6 form-group mb-2">
            <label for="contact">Contact</label>
            <input
              type="number"
              class="form-control"
              id="contact"
              v-model="contact"
              placeholder="123-45-678"
              required
            />
          </div>
          <div class="col-md-6 form-group mb-2">
            <label>Location</label>
            <input
              v-model="location"
              class="mb-3 form-control"
              value-field="id"
              text-field="name"
            />
          </div>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('new-customer')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if="loader3"><b-spinner small/></span>
            <span v-else
              ><i class="fas fa-check-circle"></i> Submit</span
            ></b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      id="edit-customer"
      centered
      title="Edit Customer  "
      title-class="font-14"
      hide-footer
    >
      <form @submit.prevent="editCustomer">
        <div class="form-group mb-2">
          <input v-model="id" type="hidden" />
          <label>Customer Name</label>
          <input v-model="name" type="text" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Contact</label>
          <input v-model="contact" type="text" class="mb-3 form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Email</label>
          <input v-model="email" type="email" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Location</label>
          <input v-model="location" type="text" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('edit-customer')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>


    <b-modal id="new-customer-import" centered title="Upload Customers" title-class="font-18" hide-footer>
          <form @submit.prevent= "UpLoadCustomers">
          
             
            <div class="form-group my-2">
            <label>Select the File</label>
            <input type="file" v-on:change="onLogoChange" class="form-control" />
            </div>

              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-customer-import')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>

    <b-modal
      id="delete-customer"
      centered
      title="Delete Customer  "
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="removeCustomer">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete this Customer: <b>{{ name }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30 fw-bold"
            variant="secondary"
            @click="$bvModal.hide('delete-customer')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="danger">
            <span v-if="loader2"><b-spinner small/></span>
            <span v-else><i class="fas fa-check-circle"></i> YES</span>
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { customerComputed, customerMethods } from "@/state/helpers";

export default {
  page: {
    title: "Our Customers",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Customers",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Customers", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Full Name", visible: true },
        { key: "contact", label: "Tel. Contact", visible: true },
        { key: "email", label: "Email", visible: true },
        { key: "location", label: "Location", visible: true },
        { key: "addedby", label: "Added By", visible: true },
        { key: "addedon", label: "Since", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      contact: "",
      location: "",
      email: "",

      //Loaders
      loader: "", // Editing Customer details
      loader2: "", // For confirming deleting a customer
      loader3: "", // For Adding a new customer
    };
  },
  computed: {
    ...customerComputed,
    List() {
      return this.customers.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.customers.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.customers.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchCustomers();
    this.TotalRows = this.customers.length;
    this.isBusy = false;
  },
  methods: {
    ...customerMethods,
    clearFields() {
      this.id = "";
      this.name = "";
      this.contact = "";
      this.location = "";
      this.email = "";
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name, contact, email, location) {
      this.loader = true;
      this.id = id;
      this.name = name;
      this.contact = contact;
      this.email = email == "-" ? "" : email;
      this.location = location == "-" ? "" : location;
      this.$bvModal.show("edit-customer");
      this.loader = false;
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-customer");
    },
        exportData() {
  return this.customers.map(customer => ({
    name: customer.name,
    contact: customer.contact || '', 
    location: customer.location || '', 
    email: customer.email || '', 
    addedby: customer.addedby.username || '', 
    addedon: customer.addedon || '', 

  }));
},

    async addCustomer() {
      this.loader3 = true;
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("contact", this.contact);
      formData.append("location", this.location);
      formData.append("email", this.email);
      let url = "/create_customer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchCustomers();
          this.$bvModal.hide("new-customer");
          this.name = "";
          this.contact = "";
          this.email = "";
          this.location = "";
        }
      });
      this.loader3 = false;
    },
      async downloadCsv() {
      axios.get('/download-csv-customer')
        .then(response => {
          // Handle the response (e.g., trigger file download)
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'customer.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          // Handle errors
          this.$toast.error('Error downloading CSV:', error);
        });
    },
    onLogoChange(e){ this.importcustomers = e.target.files[0]; },
    async UpLoadCustomers() { 
        const config = { headers: { 'content-type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append("importcustomers", this.importcustomers);
        let url = "/uploadcustomers";
        await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.$bvModal.hide('new-customer-import');
            this.importcustomers="";
            this.fetchCustomers();
          }
        });
      },
    async editCustomer() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("contact", this.contact);
      formData.append("location", this.location);
      let url = "/update_customer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchCustomers();
          this.$bvModal.hide("edit-customer");
          this.name = "";
          this.contact = "";
          this.email = "";
          this.location = "";
        }
      });
    },
    async removeCustomer() {
      this.loader2 = true;
      let obj = {
        id: this.id,
      };
      let url = "/delete_customer";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchCustomers();
          this.$bvModal.hide("delete-customer");
        }
      });
      this.loader2 = false;
    },
  },
};
</script>
